import { analyzerDate, lengthRental, offices, officesOptions, priceKpi, repricingPass, repricingPassesInfo, userData } from "@signals"
import { analyzerCarPick, analyzerFilters, responseData, tableTabSelected } from "Pages/AnalyzersV2/@signals"
import { carPickOf, freshnessOf, scopeParams } from "Pages/AnalyzersV2/@services/askEvidence"
import { longAt } from "Pages/AnalyzersV2/@services/passCompare"

/**
 * What every "Ask Iris" of an analyzer shares (CU-869fkdhjv phase 3, plan § 2.4), read from the screen's signals at
 * click time: the section, the scope as `params`, the freshness, the labels the questions add (office, length or
 * date) and whether there is anything to explain. The pure part is `askEvidence.scopeParams` / `freshnessOf`.
 *
 * The car pick of CU-869fmpqfm (`analyzerCarPick`) travels as its label (`carPickOf`); All cars → absent.
 */
const single = value => (Array.isArray(value) ? (value.length === 1 ? value[0] : null) : value)

export const hasDsRepricing = () => !!userData.value?.featuresV2?.ds_repricing

// a response is on screen, and it is not "no results"
export const analyzerHasData = () => {
	const res = responseData.value || {}
	return Object.keys(res).length > 0 && !res.no_results
}

export function analyzerAskContext({ currency, mainName } = {}) {
	const res = responseData.value || {}
	const dsRepricing = hasDsRepricing()
	const office = res.officeData?.name ? res.officeData : {
		name: officesOptions.value.find(o => String(o.value) === String(offices.value))?.label,
		officeID: offices.value,
	}
	const pass = dsRepricing && repricingPass.value
		? repricingPassesInfo.value.find(p => p.execution_id === repricingPass.value)
		: null
	const passLabel = pass ? ['Repricing pass', pass.slot ? longAt(String(pass.slot).replace('T', ' ')) : null].filter(Boolean).join(' · ') : null
	const lor = single(lengthRental.value)
	const date = single(analyzerDate.value)
	const section = res.type || 'dor'
	const params = scopeParams({
		office,
		executionDateTime: res.executionDateTime,
		passLabel,
		columns: res.xlist,
		currency,
		minMax: tableTabSelected.value,
		daily: !!priceKpi.value,
		mainName,
		lor: section === 'lor' ? null : lor,
		date: section === 'lor' ? date : null,
		filters: analyzerFilters.value,
		carPick: carPickOf(analyzerCarPick.value),
	})
	// the labels a chart, KPI or reading question adds after its own: the office, then the length (or the date in LOR)
	const labels = [
		office?.name || null,
		section === 'lor' ? (date ? { date } : null) : (lor != null ? { days: lor } : null),
	]
	return { section, dsRepricing, params, freshness: freshnessOf(res.executionDateTime), labels, officeName: office?.name || null, lor, date }
}
